import {environment} from "../environments/environment.dev";
export * from './app.component';
